import { Box, Stack, Typography, useTheme } from '@mui/material'
import { ArrowDownIcon } from '../../../../../components/icons'

type ColorScaleProps = {
  value: number | string
  color: string
  isSelected: boolean
  isEndValue?: boolean
  range: [number, number] | null,
  prevValue: number
}

export const ColorScaleItem = ({ prevValue,range, value, color, isSelected, isEndValue = false }: ColorScaleProps) => {
  const theme = useTheme()
  const [min, max] = range || []

  const getBorderColors = (value)=>{
    return !range || (value >= min! && value <= max!)
      ? theme.palette.green[700]
      : theme.palette.red[700]
  }

  const borderColor = getBorderColors(value)
  const isDiffGroup = () => {
    if(prevValue === null || prevValue === undefined) return false
    return getBorderColors(prevValue) !== borderColor
  }
  //const borderColor = isEndValue ? theme.palette.red[700] : theme.palette.green[700]

  return (
    <Stack
      alignItems="center"

      sx={{
        p: 0.5,
        ml: isDiffGroup() ? '24px' : 0,
      }}
      borderTop={`2px solid ${borderColor}`}
      position="relative"
      flexGrow={1}
    >
      {isSelected && (
        <Box
          sx={{
            position: 'absolute',
            top: -24,
            left: '50%',
            transform: 'translateX(-50%)',
            height: 0,
          }}
        >
          <ArrowDownIcon
            sx={{
              color: theme.palette.red[800],
              fontSize: '0.875rem',
            }}
          />
        </Box>
      )}
      <Typography fontSize="0.875rem" color="primary.dark" fontWeight="500">
        {value}
      </Typography>
      <Box
        sx={{
          width: 21,
          height: 24,
          backgroundColor: color,
          borderRadius: 1,
        }}
      />
    </Stack>
  )
}